export default "__VITE_ASSET__C97p0L30__"